/**
 * Picks v2 or v1 of the AudioBook edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AudioBookAddEditPage   from './AudioBookAddEditPage';
import AudioBookAddEditPageV2 from './AudioBookAddEditPageV2';

export default function AudioBookAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AudioBookAddEditPageV2 : AudioBookAddEditPage;
  return <Component {...props} />;
}
